export { default as ColorThief } from "./color-thief";
